import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  Divider,
  Input,
  InputGroup,
  InputLeftAddon,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import useAuth from "hooks/useAuth";
import useAxiosPrivate from "hooks/useAxiosPrivate"; // Ensure this is imported

const modules = {
  toolbar: [
    [{ header: [] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { align: [] },
      { indent: "+1" },
      { indent: "-1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "indent",
  "link",
  "image",
];

function NewArticle() {
  const [currentTitle, setCurrentTitle] = useState("");
  const [currentSummary, setCurrentSummary] = useState("");
  const [currentDescription, setCurrentDescription] = useState("");
  const [currentTags, setCurrentTags] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();

  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate(); // Ensure this is called
  const { handleGetArticles } = useOutletContext();

  const handleSave = async () => {
    const data = {
      title: currentTitle,
      summary: currentSummary,
      description: currentDescription,
      tags: currentTags,
    };
    try {
      const response = await axiosPrivate.post(
        "/articles/create-article",
        data
      );
      if (response) {
        toast({
          title: "Article created.",
          description: "Your article has been created successfully.",
          status: "success",
          duration: 2000,
        });
        handleGetArticles(); // Refresh the articles
        navigate("/landing/knowledgebase");
      }
    } catch (error) {
      toast({
        title: "Error.",
        description: "There was an error creating your article.",
        status: "error",
        duration: 3000,
      });
      console.error("Error saving article:", error);
    }
  };

  const handleTagsChange = (e) => {
    const tagsArray = e.target.value.split(/,\s*/);
    setCurrentTags(tagsArray);
  };

  // Colors
  const dividerColor = useColorModeValue("#dcdcdc", "#4a5568");

  return (
    <Box>
      <Card>
        <Box
          display="flex"
          justifyContent="space-between"
          p={5}
          alignItems="center"
          gap={"10px"}
        >
          <InputGroup>
            <InputLeftAddon>Title</InputLeftAddon>
            <Input
              value={currentTitle}
              onChange={(e) => setCurrentTitle(e.target.value)}
              size="md"
              borderRadius={"4px"}
            />
          </InputGroup>
          <InputGroup>
            <InputLeftAddon>Tags</InputLeftAddon>
            <Input
              value={currentTags.join(", ")}
              onChange={handleTagsChange}
              size="md"
              borderRadius={"4px"}
            />
          </InputGroup>
          <Button colorScheme="blue" onClick={handleSave} borderRadius={"4px"}>
            Save
          </Button>
        </Box>
        <Divider borderColor={dividerColor} />
        <Box px={5} pt={5}>
          <InputGroup>
            <InputLeftAddon>Summary</InputLeftAddon>
            <Input
              value={currentSummary}
              onChange={(e) => setCurrentSummary(e.target.value)}
              size="md"
              borderRadius={"4px"}
            />
          </InputGroup>
        </Box>
        <Box p={5}>
          <ReactQuill
            theme="snow"
            formats={formats}
            modules={modules}
            value={currentDescription}
            onChange={setCurrentDescription}
          />
        </Box>
      </Card>
    </Box>
  );
}

export default NewArticle;
